//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cursos from '@/api/promotores/cursos.api';
import ExamenesAPI from "@/api/promotores/examenes.api";
import CategoriasAPI from "@/api/promotores/cursos/categorias.api";
import EspecialidadesAPI from "@/api/promotores/cursos/especialidades.api";

import FilePicker from '@/components/FilePicker'
import UploadImageInput from '@/components/UploadImageInput'
import CategoriaForm from './CategoriaForm'
import EspecialidadForm from './EspecialidadForm'

export default {
  components: { UploadImageInput, FilePicker },
  data() {
    return {
      qeditor: '',
      curso: {
        nombre: null,
        video: null,
        destacado: false,
        examen_id: null,
        categoria_id: null,
        especialidades: [],
        documento: null,
        portada: null,
        avatar: null,
        contenido: '',
        status: 'privado',
      },
      loading: false,
      ratio: 70,
      status: [
        { value: 'publico', label: 'Publico', caption: 'Visible por todos.' },
        { value: 'privado', label: 'Privado', caption: 'Visible solo para usuarios de nivel de administrador.' },
      ],

      examenes: [],
			optionsExamenes: [],
			loadingExamenes: false,

      categorias: [],
			optionsCategorias: [],
			loadingCategorias: false,

      especialidades: [],
			optionsEspecialidades: [],
			loadingEspecialidades: false,
    }
  },

  mounted() {
    this.$route.params.curso && this.loadCurso()
    this.loadExamenes();
    this.loadCategorias();
    this.loadEspecialidades();
  },

  methods: {
    async loadCurso() {
      try {
        this.loading = true
        this.curso = await Cursos.get(this.$route.params.curso)
        
        if (this.curso.contenido) {
          this.qeditor = this.curso.contenido
        }
      } finally {
        this.loading = false
      }
    },

    async submit() {
      try {
				this.loading = true
        let payload = {
					
					nombre: this.curso.nombre,
					destacado: this.curso.destacado,
					video: this.curso.video,
					examen_id: this.curso.examen_id,
					categoria_id: this.curso.categoria_id,
					especialidades: (this.curso.especialidades || []).map((especialidad) => especialidad.id),
          contenido: this.qeditor,
          status: this.curso.status,
				}

        if (this.curso.id) {
          payload.id = this.curso.id
        }

				if (this.curso.documento instanceof File) {
					payload.documento = this.curso.documento
				}

				if (this.curso.portada instanceof File) {
					payload.portada = this.curso.portada
				}

				if (this.curso.avatar instanceof File) {
					payload.avatar = this.curso.avatar
				}

				await Cursos.save(payload)
        this.$router.push({ name: 'cursos' })
			} finally {
				this.loading = false
			}
    },

    async loadExamenes() {
			try {
				this.loadingExamenes = true
				this.examenes = await ExamenesAPI.all();
				this.optionsExamenes = this.examenes;
			} finally {
				this.loadingExamenes = false
			}
    },

    filterExamenes(val, update) {

      if (val === "") {
        update(() => {
          this.optionsExamenes = this.examenes;
        });
        return;
      }

      update(() => {
        const needle = val.toLowerCase();

        this.optionsExamenes = this.examenes.filter(
          (examen) => examen.nombre.toLowerCase().indexOf(needle) > -1
        );
      });
    },

    filterCategorias(val, update) {

      if (val === "") {
        update(() => {
          this.optionsCategorias = this.categorias;
        });
        return;
      }

      update(() => {
        const needle = val.toLowerCase();

        this.optionsCategorias = this.categorias.filter(
          (categoria) => categoria.nombre.toLowerCase().indexOf(needle) > -1
        );
      });
    },

		async loadCategorias() {
			try {
				this.loadingCategorias = true
				this.categorias = await CategoriasAPI.all()
				this.optionsCategorias = this.categorias;
			} finally {
				this.loadingCategorias = false
			}
		},

		async createCategoria(val, done) {
			try {
				this.loadingCategorias = true
				const categoria = await CategoriasAPI.create({ nombre: val })
				
				done(categoria)
				this.loadCategorias()
			} finally {
				this.loadingCategorias = false
			}
		},

		async loadEspecialidades() {
			try {
				this.loadingEspecialidades = true
				this.especialidades = await EspecialidadesAPI.all()
			} finally {
				this.loadingEspecialidades = false
			}
		},

		filterEspecialidades(val, update) {
      if (val === "") {
        update(() => {
          this.optionsEspecialidades = this.especialidades;
        });
        return;
      }

      update(() => {
        const needle = val.toLowerCase();

        this.optionsEspecialidades = this.especialidades.filter(
          (especialidad) => especialidad.nombre.toLowerCase().indexOf(needle) > -1
        );
      });
    },

    agregarCategoria() {
			this.$q.dialog({
				component: CategoriaForm,
			})
				.onOk((categoria) => {
					
				})
		},

    agregarEspecialidad() {
			this.$q.dialog({
				component: EspecialidadForm,
			})
				.onOk((especialidad) => {
					
				})
		},
  }
}
